import { SelectChangeEvent } from '@mui/material/Select';
import React, { ReactNode } from 'react';
import { Components, styles } from './styled';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-angle-down.svg';
import { ReactComponent as ClearIcon } from '../../../assets/icons/icon-close.svg';

const ProjectSelect = ({
  value,
  onChangeSelectedItem,
  onClearValue,
  name,
  errorMessage,
  disabled,
  placeholder,
  processShownLabel,
  children,
}: {
  value: string | undefined;
  onChangeSelectedItem: (e: SelectChangeEvent<string | undefined>) => void;
  onClearValue?: () => void;
  name?: string;
  errorMessage?: string;
  placeholder?: string;
  disabled?: boolean;
  processShownLabel?: (value: any) => any;
  children: React.ReactNode;
}) => {
  const _onChangeSelectedItem = (e: SelectChangeEvent<unknown>) => {
    onChangeSelectedItem?.(e as SelectChangeEvent<string | undefined>);
  };

  const defaultProcessShownLabel = (value: string | undefined) => value;

  const _onClearValue = () => {
    onClearValue?.();
  };

  return (
    <Components.Container>
      <Components.Select
        value={value || ''}
        onChange={_onChangeSelectedItem}
        {...(name && { name })}
        IconComponent={ArrowDownIcon}
        {...(onClearValue &&
          value?.length && {
            endAdornment: (
              <Components.ClearButton onClick={_onClearValue}>
                <ClearIcon width={12} height={12} />
              </Components.ClearButton>
            ),
          })}
        {...(placeholder &&
          placeholder.length > 0 && {
            displayEmpty: true,
            renderValue: (value: string | undefined) =>
              value !== '' && value !== undefined
                ? processShownLabel
                  ? processShownLabel(value)
                  : defaultProcessShownLabel(value)
                : placeholder,
          })}
        disabled={disabled}
        // @ts-ignore
        MenuProps={{ sx: styles.SelectMenu }}>
        {children}
      </Components.Select>
      {errorMessage && <Components.ErrorMessage>{errorMessage}</Components.ErrorMessage>}
    </Components.Container>
  );
};

export default ProjectSelect;
